export default {
    data: {
        old_password: '',
        new_password: '',
    },
    loading: false,
    success: false,
    error: false,
}
